/* DillySocks — PDP Grössentabelle-Link + Overlay.

   Fügt in die "Grösse wählen"-Zeile (.ds-size-heading) rechts einen
   "Grössentabelle"-Link ein. Klick öffnet ein zentriertes Overlay mit der
   produktbezogenen Tabelle (gleiche Daten/Optik wie der Quick-Add-Slider).
   Kein passender Tabellen-Treffer -> Link fällt auf die Übersichtsseite
   /pages/groessentabellen zurück.

   Grössen kommen aus der JSON-Insel [data-ds-sizeguide-data] (echte
   Variantentitel des Produkts, in Liquid gerendert). SIZE_CHARTS ist bewusst
   identisch zu ds-quick-add.js gehalten. */
(function () {
  'use strict';

  var SIZE_GUIDE_URL = '/pages/groessentabellen';

  // Übersetzte Strings aus dem JSON-Block, den ds-pdp-sizeguide.liquid rendert
  // (dieses Asset ist ein statisches <script src>, kein {% javascript %}-Tag).
  var I18N_EL = document.querySelector('[data-ds-sizeguide-i18n]');
  var I18N = I18N_EL ? JSON.parse(I18N_EL.textContent) : {};

  /* Grössentabellen wie auf der Live-PDP / im Quick-Add — gerendert werden nur
     die Zeilen, deren Grösse das Produkt tatsächlich hat. */
  var SIZE_CHARTS = [
    {
      head: ['EU', 'CM', 'US', 'UK'],
      rows: {
        '36-40': ['23-25', '4.5-7.5', '4-7'],
        '41-46': ['25.5-29', '8-12', '7.5-11.5'],
      },
    },
    {
      head: [I18N.kidsHeader, 'EU', 'CM', 'US'],
      rows: {
        '0-12M': ['15-18', '3-5.5', '8.5-11.5'],
        '12-24M': ['19-22', '6-6.5', '12-14'],
        '2-3Y': ['23-26', '6.5-7.5', '14.5-16.5'],
        '4-6Y': ['27-30', '7.5-8', '17-19'],
        '7-9Y': ['31-34', '8.5-9.5', '19.5-21.5'],
      },
    },
  ];

  function readData() {
    var el = document.querySelector('[data-ds-sizeguide-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function matchChart(sizes) {
    for (var i = 0; i < SIZE_CHARTS.length; i++) {
      for (var j = 0; j < sizes.length; j++) {
        if (SIZE_CHARTS[i].rows[sizes[j]]) return SIZE_CHARTS[i];
      }
    }
    return null;
  }

  function buildTableHTML(chart, sizes) {
    var html = '<tr>' + chart.head.map(function (h, j) {
      return j === 0 ? '<th>' + h + '</th>' : '<td>' + h + '</td>';
    }).join('') + '</tr>';
    sizes.forEach(function (t) {
      var row = chart.rows[t];
      if (!row) return;
      html += '<tr><th>' + t + '</th>' + row.map(function (c) { return '<td>' + c + '</td>'; }).join('') + '</tr>';
    });
    return html;
  }

  /* ---- Overlay einmalig erzeugen ---------------------------------------- */
  var els = null;
  function ensureEls() {
    if (els) return els;

    var scrim = document.createElement('div');
    scrim.className = 'ds-sizeguide-scrim';

    var modal = document.createElement('div');
    modal.className = 'ds-sizeguide-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', I18N.link);
    modal.innerHTML =
      '<div class="ds-sizeguide-head">' +
      '  <h2 class="ds-sizeguide-title">' + I18N.link + '</h2>' +
      '  <button type="button" class="ds-sizeguide-close" aria-label="' + I18N.close + '"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>' +
      '</div>' +
      '<div class="ds-sizeguide-body">' +
      '  <table class="ds-sizeguide-table"></table>' +
      '  <a class="ds-sizeguide-more" href="' + SIZE_GUIDE_URL + '" target="_blank" rel="noopener">' + I18N.moreInfo + '</a>' +
      '</div>';

    document.body.appendChild(scrim);
    document.body.appendChild(modal);

    scrim.addEventListener('click', close);
    modal.querySelector('.ds-sizeguide-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    els = { scrim: scrim, modal: modal };
    return els;
  }

  function open(chart, sizes) {
    var e = ensureEls();
    e.modal.querySelector('.ds-sizeguide-table').innerHTML = buildTableHTML(chart, sizes);
    e.modal.classList.add('is-open');
    e.scrim.classList.add('is-open');
    e.modal.querySelector('.ds-sizeguide-close').focus({ preventScroll: true });
  }
  function close() {
    if (!els) return;
    els.modal.classList.remove('is-open');
    els.scrim.classList.remove('is-open');
  }

  /* ---- Link in die "Grösse wählen"-Zeile setzen ------------------------- */
  function init() {
    var heading = document.querySelector('.ds-size-heading');
    if (!heading || heading.querySelector('.ds-sizeguide-link')) return;

    var data = readData();
    var sizes = (data && data.sizes) || [];
    var chart = matchChart(sizes);

    var link = document.createElement(chart ? 'button' : 'a');
    link.className = 'ds-sizeguide-link';
    link.textContent = I18N.link;

    if (chart) {
      link.type = 'button';
      link.addEventListener('click', function () { open(chart, sizes); });
    } else {
      /* Kein produktbezogener Treffer -> Übersichtsseite. */
      link.href = SIZE_GUIDE_URL;
      link.target = '_blank';
      link.rel = 'noopener';
    }

    heading.classList.add('ds-size-heading--has-guide');
    heading.appendChild(link);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
